import { jsx as _jsx } from "react/jsx-runtime";
import styles from './HorseTabs.module.scss';
import cn from 'classnames';
import Paragraph from '../Typography/Paragraph/Paragraph';
const HorseTabs = ({ tabs, jockey, className, onClick, activeTab }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.element, className) }, { children: _jsx("div", Object.assign({ className: cn(styles.wrapper, 'd-flex justify-content-between') }, { children: tabs.map(({ value, label }) => (_jsx(Paragraph, { onClick: () => (onClick ? onClick(value) : () => { }), className: cn(styles.text, activeTab === value ? styles['isActive'] : ''), color: activeTab === value ? 'gold' : 'grey', title: label.toLocaleUpperCase() }, value))) })) })));
};
export default HorseTabs;
